export const GOOGLE_MAP_KEY = 'AIzaSyDLnurCsWfZyQYJAJOiEjnrApSqx8XaE_k';
